import CMSItem from '../../cms/cms-item/CMSItem';
import MaxWidthWrapper from '../../components/max-width-wrapper/MaxWidthWrapper';
import RoundedButtonLinkAction from '../../components/button/rounded-button-link-action/RoundedButtonLinkAction';
import styles from './project-tva-bosse-samleside.module.less';

const NoHits = ({ query, county, cmsSelectedProjects = [] }) => {
    if (query) {
        return (
            <>
                <MaxWidthWrapper>
                    <div className={styles.noHits}>
                        <p>Fant ingen bøsser. Endre søket ditt eller start din egen digitale bøsse 🙌</p>
                    </div>
                </MaxWidthWrapper>
                <div className={styles.startBosseKnapp}>
                    <RoundedButtonLinkAction to={'/project/select/template?provider=tva'}>
                        Start en digital bøsse
                    </RoundedButtonLinkAction>
                </div>
            </>
        );
    } else if (county) {
        return (
            <>
                <MaxWidthWrapper>
                    <div className={styles.noHits}>
                        <p>
                            Ingen bøsser er startet i dette området ennå. Endre søket ditt eller start din egen digitale
                            bøsse 🙌
                        </p>
                    </div>
                </MaxWidthWrapper>
                <div className={styles.startBosseKnapp}>
                    <RoundedButtonLinkAction to={'/project/select/template?provider=tva'}>
                        Start en digital bøsse
                    </RoundedButtonLinkAction>
                </div>
            </>
        );
    }

    return cmsSelectedProjects?.map((content) => {
        return <CMSItem id={content} depth={5} key={content} />;
    });
};

export default NoHits;
